function normalizeDateInput(v) {
  const s = String(v || "").trim();
  if (!s) return "";
  if (!/^\d{4}-\d{2}-\d{2}$/.test(s)) return "";

  const [y, m, d] = s.split("-").map(Number);
  if (!Number.isInteger(y) || !Number.isInteger(m) || !Number.isInteger(d)) return "";

  const dt = new Date(Date.UTC(y, m - 1, d));
  if (
    dt.getUTCFullYear() !== y ||
    dt.getUTCMonth() + 1 !== m ||
    dt.getUTCDate() !== d
  ) {
    return "";
  }
  return s;
}

export function createClientHistoryEntry() {
  return {
    lastCallDate: "",
    lastCallResult: "",
  };
}

export function hasClientHistoryEntry(entry) {
  return !!(
    String(entry?.lastCallDate || "").trim() ||
    String(entry?.lastCallResult || "").trim()
  );
}

export function normalizeClientHistoryEntry(entry = {}) {
  return {
    lastCallDate: normalizeDateInput(entry?.lastCallDate),
    lastCallResult: String(entry?.lastCallResult || "").trim(),
  };
}

export function getClientHistoryEntries(history, { includeEmpty = false } = {}) {
  const source = Array.isArray(history)
    ? history
    : history && typeof history === "object"
      ? [history]
      : [];

  return source
    .map(normalizeClientHistoryEntry)
    .filter((entry) => includeEmpty || hasClientHistoryEntry(entry));
}

export function getClientHistoryEntriesForForm(history) {
  const entries = getClientHistoryEntries(history, { includeEmpty: true });
  return entries.length ? entries : [createClientHistoryEntry()];
}

export function cleanClientHistoryForPayload(entries) {
  const cleaned = (Array.isArray(entries) ? entries : [])
    .map(normalizeClientHistoryEntry)
    .filter(hasClientHistoryEntry);

  return cleaned.length ? cleaned : [createClientHistoryEntry()];
}

export function getLatestClientHistoryEntry(history) {
  const entries = getClientHistoryEntries(history);
  return entries[entries.length - 1] || createClientHistoryEntry();
}
